import { createFileRoute } from '@tanstack/react-router'
import { HeadToHeadResearchRouteKernel, headToHeadResearchRouteKernel } from '~/features/research-workspace/route-kernels'

export const Route = createFileRoute('/research/head-to-head')({
  ...headToHeadResearchRouteKernel,
  component: HeadToHeadResearchRoute,
})

function HeadToHeadResearchRoute() {
  return <HeadToHeadResearchRouteKernel route={Route} />
}
